export const customPdfAppearanceSectionsValues = [
  "qrCode",
  "conditions",
  "customSection1",
  "customSection2",
] as const;

export const CustomEventInfoAppearanceSectionValues = [
  "mainCharacteristics",
  "locations",
  "dates",
  "pictures",
  "links",
] as const;

export const customAppearanceModelValues = [
  "fourQuarters",
  "horizontal",
  "mix",
] as const;

export const customAppearanceOrderValues = [
  "qrCodeFirst",
  "qrCodeLast",
] as const;

export type CustomAppearanceOrder =
  (typeof customAppearanceOrderValues)[number];

export type CustomPdfAppearanceSection =
  (typeof customPdfAppearanceSectionsValues)[number];

export type CustomAppearanceModel =
  (typeof customAppearanceModelValues)[number];

export type CustomEventInfoAppearanceSection =
  (typeof CustomEventInfoAppearanceSectionValues)[number];

import { Prisma } from "@prisma/client";
import { fileSelectValues } from "./file.types";

export const customPdfAppearanceTemplateTypeValues =
  Prisma.validator<Prisma.CustomPdfAppearanceTemplateDefaultArgs>()({
    include: {
      backgroundPicture: {
        select: fileSelectValues,
      },
      headerPicture: {
        select: fileSelectValues,
      },
      textPictures: {
        select: fileSelectValues,
      },
      previewPicture: {
        select: fileSelectValues,
      },
    },
  });

export type CustomPdfAppearanceTemplateType =
  Prisma.CustomPdfAppearanceTemplateGetPayload<
    typeof customPdfAppearanceTemplateTypeValues
  >;
